import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Created Date', 'createdDate', true, 'desc', 'left'),
  new TableColumn('Even ID', 'eventId', true, 'desc', 'left'),
  new TableColumn('Message', 'message', true, 'desc', 'left'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
